import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Shield, User, Clock, Scale, Users, FileCheck, Lock, Mail } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const PoliticaPrivacidadPage = () => {
  return (
    <div className="min-h-screen bg-[#0a0a0a] text-white">
      <Header />
      
      {/* Hero Section */}
      <section className="relative pt-24 pb-16 bg-gradient-to-b from-[#1a1a1a] to-[#0a0a0a]">
        <div className="max-w-4xl mx-auto px-6">
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 text-white/60 hover:text-white transition-colors mb-8"
          >
            <ArrowLeft className="w-4 h-4" />
            Volver al inicio
          </Link>
          
          <div className="flex items-center gap-4 mb-6">
            <div className="w-12 h-12 rounded-full bg-[#e4002b]/20 flex items-center justify-center">
              <Shield className="w-6 h-6 text-[#e4002b]" />
            </div>
            <h1 className="text-3xl md:text-4xl font-bold">Política de Privacidad</h1>
          </div>
          
          <p className="text-white/60 text-sm">
            Última actualización: Febrero 2026
          </p>
        </div>
      </section>
      
      {/* Content */}
      <section className="py-12">
        <div className="max-w-4xl mx-auto px-6">
          <div className="space-y-10">
            
            {/* Section 1 */}
            <div className="bg-[#141414] rounded-xl p-8 border border-white/10">
              <h2 className="text-xl font-bold text-[#e4002b] mb-6 flex items-center gap-3">
                <span className="w-8 h-8 rounded-full bg-[#e4002b]/20 flex items-center justify-center text-sm">1</span>
                ¿QUIÉN ES EL RESPONSABLE DEL TRATAMIENTO DE SUS DATOS?
              </h2>
              
              <div className="grid md:grid-cols-2 gap-4">
                <div className="bg-[#0a0a0a] rounded-lg p-4 border border-white/5">
                  <span className="text-white/50 text-sm">Identidad</span>
                  <p className="font-semibold mt-1">Versión Digital S.L.</p>
                </div>
                <div className="bg-[#0a0a0a] rounded-lg p-4 border border-white/5">
                  <span className="text-white/50 text-sm">C.I.F.</span>
                  <p className="font-semibold mt-1">B98660459</p>
                </div>
                <div className="bg-[#0a0a0a] rounded-lg p-4 border border-white/5">
                  <span className="text-white/50 text-sm">Dirección</span>
                  <p className="font-semibold mt-1">Calle Martínez Ferrando 6, CD. 46004, Valencia</p>
                </div>
                <div className="bg-[#0a0a0a] rounded-lg p-4 border border-white/5">
                  <span className="text-white/50 text-sm">Correo electrónico</span>
                  <a href="mailto:administracion@versiondigital.es" className="font-semibold mt-1 text-[#e4002b] hover:underline block">
                    administracion@versiondigital.es
                  </a>
                </div>
              </div>
            </div>
            
            {/* Section 2 */}
            <div className="bg-[#141414] rounded-xl p-8 border border-white/10">
              <h2 className="text-xl font-bold text-[#e4002b] mb-6 flex items-center gap-3">
                <span className="w-8 h-8 rounded-full bg-[#e4002b]/20 flex items-center justify-center text-sm">2</span>
                ¿CON QUÉ FINALIDAD TRATAMOS SUS DATOS PERSONALES?
              </h2>
              
              <p className="text-white/70 mb-6 leading-relaxed">
                En www.cinemastreaming.es tratamos la información que nos facilitan las personas interesadas con las siguientes finalidades:
              </p>
              
              <div className="space-y-4">
                <div className="flex gap-4 items-start">
                  <div className="w-10 h-10 rounded-full bg-blue-500/20 flex items-center justify-center flex-shrink-0 mt-1">
                    <Mail className="w-5 h-5 text-blue-400" />
                  </div>
                  <div>
                    <h4 className="font-semibold text-white mb-1">Gestión de consultas</h4>
                    <p className="text-white/60 text-sm">Atender las solicitudes de información recibidas a través de los formularios de contacto o correos electrónicos.</p>
                  </div>
                </div>
                
                <div className="flex gap-4 items-start">
                  <div className="w-10 h-10 rounded-full bg-green-500/20 flex items-center justify-center flex-shrink-0 mt-1">
                    <FileCheck className="w-5 h-5 text-green-400" />
                  </div>
                  <div>
                    <h4 className="font-semibold text-white mb-1">Relación contractual</h4>
                    <p className="text-white/60 text-sm">Gestionar el alta, soporte técnico y mantenimiento del servicio Bravo y la contratación de contenidos de CinemaStreaming.</p>
                  </div>
                </div>
                
                <div className="flex gap-4 items-start">
                  <div className="w-10 h-10 rounded-full bg-purple-500/20 flex items-center justify-center flex-shrink-0 mt-1">
                    <Users className="w-5 h-5 text-purple-400" />
                  </div>
                  <div>
                    <h4 className="font-semibold text-white mb-1">Comunicaciones comerciales</h4>
                    <p className="text-white/60 text-sm">Siempre que contemos con su consentimiento explícito, enviar boletines informativos (newsletters) sobre la programación de óperas, ballets, conciertos y novedades de Versión Digital.</p>
                  </div>
                </div>
                
                <div className="flex gap-4 items-start">
                  <div className="w-10 h-10 rounded-full bg-orange-500/20 flex items-center justify-center flex-shrink-0 mt-1">
                    <Scale className="w-5 h-5 text-orange-400" />
                  </div>
                  <div>
                    <h4 className="font-semibold text-white mb-1">Cumplimiento legal</h4>
                    <p className="text-white/60 text-sm">Cumplir con las obligaciones legales y tributarias derivadas de nuestra actividad comercial.</p>
                  </div>
                </div>
              </div>
            </div>
            
            {/* Section 3 */}
            <div className="bg-[#141414] rounded-xl p-8 border border-white/10">
              <h2 className="text-xl font-bold text-[#e4002b] mb-6 flex items-center gap-3">
                <span className="w-8 h-8 rounded-full bg-[#e4002b]/20 flex items-center justify-center text-sm">3</span>
                ¿POR CUÁNTO TIEMPO CONSERVAREMOS SUS DATOS?
              </h2>
              
              <p className="text-white/70 mb-4 leading-relaxed">
                Los datos personales proporcionados se conservarán:
              </p>
              
              <ul className="space-y-3">
                <li className="flex items-start gap-3">
                  <Clock className="w-5 h-5 text-[#e4002b] mt-0.5 flex-shrink-0" />
                  <span className="text-white/70">Mientras se mantenga la relación mercantil o de servicios.</span>
                </li>
                <li className="flex items-start gap-3">
                  <Clock className="w-5 h-5 text-[#e4002b] mt-0.5 flex-shrink-0" />
                  <span className="text-white/70">Hasta que el interesado solicite su supresión o retire su consentimiento.</span>
                </li>
                <li className="flex items-start gap-3">
                  <Clock className="w-5 h-5 text-[#e4002b] mt-0.5 flex-shrink-0" />
                  <span className="text-white/70">Durante los plazos legales obligatorios (fiscales y contables) una vez finalizada la relación.</span>
                </li>
              </ul>
            </div>
            
            {/* Section 4 */}
            <div className="bg-[#141414] rounded-xl p-8 border border-white/10">
              <h2 className="text-xl font-bold text-[#e4002b] mb-6 flex items-center gap-3">
                <span className="w-8 h-8 rounded-full bg-[#e4002b]/20 flex items-center justify-center text-sm">4</span>
                ¿CUÁL ES LA LEGITIMACIÓN PARA EL TRATAMIENTO DE SUS DATOS?
              </h2>
              
              <p className="text-white/70 mb-4 leading-relaxed">
                La base legal para el tratamiento de sus datos depende de la finalidad:
              </p>
              
              <div className="space-y-3">
                <div className="bg-[#0a0a0a] rounded-lg p-4 border border-white/5">
                  <h4 className="font-semibold text-white mb-1">Ejecución de un contrato</h4>
                  <p className="text-white/60 text-sm">Para la gestión de servicios Bravo y CinemaStreaming.</p>
                </div>
                <div className="bg-[#0a0a0a] rounded-lg p-4 border border-white/5">
                  <h4 className="font-semibold text-white mb-1">Consentimiento del interesado</h4>
                  <p className="text-white/60 text-sm">Para el envío de comunicaciones comerciales y respuesta a consultas web.</p>
                </div>
                <div className="bg-[#0a0a0a] rounded-lg p-4 border border-white/5">
                  <h4 className="font-semibold text-white mb-1">Interés legítimo</h4>
                  <p className="text-white/60 text-sm">Para la seguridad del sitio web y marketing directo a clientes actuales de la empresa.</p>
                </div>
              </div>
            </div>
            
            {/* Section 5 */}
            <div className="bg-[#141414] rounded-xl p-8 border border-white/10">
              <h2 className="text-xl font-bold text-[#e4002b] mb-6 flex items-center gap-3">
                <span className="w-8 h-8 rounded-full bg-[#e4002b]/20 flex items-center justify-center text-sm">5</span>
                ¿A QUÉ DESTINATARIOS SE COMUNICARÁN SUS DATOS?
              </h2>
              
              <p className="text-white/70 mb-4 leading-relaxed">
                Versión Digital S.L. no cederá sus datos a terceros, salvo en los siguientes casos:
              </p>
              
              <ul className="space-y-3">
                <li className="flex items-start gap-3">
                  <div className="w-2 h-2 rounded-full bg-[#e4002b] mt-2 flex-shrink-0" />
                  <div>
                    <span className="font-semibold text-white">Obligación legal:</span>
                    <span className="text-white/70"> A las Administraciones Públicas y autoridades competentes.</span>
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <div className="w-2 h-2 rounded-full bg-[#e4002b] mt-2 flex-shrink-0" />
                  <div>
                    <span className="font-semibold text-white">Proveedores de servicios:</span>
                    <span className="text-white/70"> Empresas encargadas del tratamiento de datos que prestan servicios técnicos (hosting, CRM, plataformas de envío de email) y que cumplen con los estándares de seguridad exigidos por el RGPD.</span>
                  </div>
                </li>
              </ul>
            </div>
            
            {/* Section 6 */}
            <div className="bg-[#141414] rounded-xl p-8 border border-white/10">
              <h2 className="text-xl font-bold text-[#e4002b] mb-6 flex items-center gap-3">
                <span className="w-8 h-8 rounded-full bg-[#e4002b]/20 flex items-center justify-center text-sm">6</span>
                ¿CUÁLES SON SUS DERECHOS AL FACILITARNOS SUS DATOS?
              </h2>
              
              <p className="text-white/70 mb-6 leading-relaxed">
                Usted tiene derecho a obtener confirmación sobre si en Versión Digital S.L. estamos tratando datos personales que les conciernan, o no. Los interesados tienen derecho a:
              </p>
              
              <div className="grid md:grid-cols-2 gap-3">
                <div className="bg-[#0a0a0a] rounded-lg p-4 border border-white/5">
                  <h4 className="font-semibold text-white mb-1">Acceso</h4>
                  <p className="text-white/60 text-sm">Saber qué datos tratamos.</p>
                </div>
                <div className="bg-[#0a0a0a] rounded-lg p-4 border border-white/5">
                  <h4 className="font-semibold text-white mb-1">Rectificación</h4>
                  <p className="text-white/60 text-sm">Corregir datos inexactos.</p>
                </div>
                <div className="bg-[#0a0a0a] rounded-lg p-4 border border-white/5">
                  <h4 className="font-semibold text-white mb-1">Supresión ("Olvido")</h4>
                  <p className="text-white/60 text-sm">Solicitar la eliminación de sus datos.</p>
                </div>
                <div className="bg-[#0a0a0a] rounded-lg p-4 border border-white/5">
                  <h4 className="font-semibold text-white mb-1">Oposición</h4>
                  <p className="text-white/60 text-sm">Dejar de recibir comunicaciones comerciales.</p>
                </div>
                <div className="bg-[#0a0a0a] rounded-lg p-4 border border-white/5">
                  <h4 className="font-semibold text-white mb-1">Limitación del tratamiento</h4>
                  <p className="text-white/60 text-sm">Solicitar el bloqueo temporal del tratamiento en casos específicos.</p>
                </div>
                <div className="bg-[#0a0a0a] rounded-lg p-4 border border-white/5">
                  <h4 className="font-semibold text-white mb-1">Portabilidad</h4>
                  <p className="text-white/60 text-sm">Recibir sus datos en un formato electrónico estructurado.</p>
                </div>
              </div>
              
              <div className="bg-blue-500/10 border border-blue-500/30 rounded-lg p-4 mt-6">
                <p className="text-blue-200 text-sm">
                  Para ejercer estos derechos, puede enviar una comunicación por escrito al domicilio social de Versión Digital S.L. o al correo electrónico{' '}
                  <a href="mailto:administracion@versiondigital.es" className="text-blue-300 hover:underline font-medium">
                    administracion@versiondigital.es
                  </a>, adjuntando copia de su DNI o documento equivalente para verificar su identidad.
                </p>
              </div>
              
              <p className="text-white/60 text-sm mt-4">
                Si considera que sus derechos no han sido debidamente atendidos, tiene derecho a presentar una reclamación ante la Agencia Española de Protección de Datos (AEPD) en{' '}
                <a href="https://www.aepd.es" target="_blank" rel="noopener noreferrer" className="text-[#e4002b] hover:underline">
                  www.aepd.es
                </a>.
              </p>
            </div>
            
            {/* Section 7 */}
            <div className="bg-[#141414] rounded-xl p-8 border border-white/10">
              <h2 className="text-xl font-bold text-[#e4002b] mb-6 flex items-center gap-3">
                <span className="w-8 h-8 rounded-full bg-[#e4002b]/20 flex items-center justify-center text-sm">7</span>
                SEGURIDAD DE LOS DATOS
              </h2>
              
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-full bg-green-500/20 flex items-center justify-center flex-shrink-0">
                  <Lock className="w-6 h-6 text-green-400" />
                </div>
                <p className="text-white/70 leading-relaxed">
                  Versión Digital S.L. se compromete al cumplimiento de su obligación de secreto de los datos de carácter personal y de su deber de guardarlos, y adoptará las medidas técnicas y organizativas necesarias para evitar su alteración, pérdida, tratamiento o acceso no autorizado.
                </p>
              </div>
            </div>
            
          </div>
        </div>
      </section>
      
      <Footer />
    </div>
  );
};

export default PoliticaPrivacidadPage;
